import { isString } from './is-string';

export const isEmptyString = (predictable: string): predictable is never => {
  return isString(predictable) && predictable.length === 0;
};
